import React from "react";

import { Swagger } from "../../pages/developer/";

export const Documentation = () => {
	return <Swagger />;
};
